import _extends from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["id"];
import React from "react";
var __jsx = React.createElement;
import { useLayoutEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { useForceUpdate } from "../../hooks";
export var Portal = function Portal(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'div' : _ref$type,
      containerRef = _ref.containerRef,
      direct = _ref.direct;
  var mountNode = useRef(null);
  var portalNode = useRef(null);
  var forceUpdate = useForceUpdate();
  useLayoutEffect(function () {
    // This ref may be null when a hot-loader replaces components on the page
    if (!mountNode.current) return; // It's possible that the content of the portal has, itself, been portaled.
    // In that case, it's important to append to the correct document element.

    var ownerDocument = mountNode.current.ownerDocument;
    var body = (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) || ownerDocument.body;
    portalNode.current = ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.createElement(type);
    body.appendChild(portalNode.current);
    forceUpdate();
    return function () {
      if (portalNode.current && body) {
        body.removeChild(portalNode.current);
      }
    };
  }, [type, forceUpdate, containerRef === null || containerRef === void 0 ? void 0 : containerRef.current]);

  if (direct && containerRef !== null && containerRef !== void 0 && containerRef.current) {
    return /*#__PURE__*/createPortal(children, containerRef.current);
  }

  return portalNode.current ? /*#__PURE__*/createPortal(children, portalNode.current) : __jsx("span", {
    ref: mountNode
  });
};
export var PortalRef = function PortalRef(_ref2) {
  var id = _ref2.id,
      props = _objectWithoutProperties(_ref2, _excluded);

  return __jsx(StyledPortalRef, _extends({
    id: id
  }, props));
};
var StyledPortalRef = styled.div.withConfig({
  displayName: "StyledPortalRef",
  componentId: "sc-133yxrv-0"
})(["height:auto;"]);
export default Portal;